const state = {
  retailSelected: null,
  cellClicked: null,
  gridIsReady: false
}

const getters = {

}

const mutations = {
  commit_productWm_cellClicked (state, cellClicked) {
    state.cellClicked = cellClicked
  },
  commit_productWm_retailSelected (state, retailSelected) {
    state.retailSelected = retailSelected
  },
  commit_productWm_gridIsReady (state, gridIsReady) {
    state.gridIsReady = gridIsReady
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/productWm.js